export default ({ request }) => ({
    ecomAmzFlipOrderSkuScmSummaryListApi(data = {}) {
      return request({
        url: '/ecom/amz/flip/order/sku/scmSummaryList',
        method: 'POST',
        data,
      })
    },
    ecomAmzFlipOrderSkuScmPurchaseGenerateApi(data = {}) {
      return request({
        url: '/ecom/amz/flip/order/sku/scmPurchaseGenerate',
        method: 'POST',
        data,
      })
    },
    ecomAmzFlipOrderSkuScmSummaryDetailListApi(data = {}) {
      return request({
        url: '/ecom/amz/flip/order/sku/scmSummary/detail/list',
        method: 'POST',
        data,
      })
    }
  })
  